// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ListCountriesQueryVariables = Types.Exact<{
  pageNumber: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageSize: Types.InputMaybe<Types.Scalars['Int']['input']>;
  keyword: Types.InputMaybe<Types.Scalars['String']['input']>;
  hasCompanies?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  hasActiveCompanies?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  hasNationalities?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type ListCountriesQuery = { __typename?: 'Query' } & {
  listCountries: { __typename?: 'ListCountries' } & Pick<Types.ListCountries, 'totalCount'> & {
      items: Array<{ __typename?: 'Country' } & Pick<Types.Country, 'id' | 'name' | 'isdCode' | 'demonym'>>;
    };
};

export const ListCountriesDocument = /*#__PURE__*/ gql`
    query listCountries($pageNumber: Int, $pageSize: Int, $keyword: String, $hasCompanies: Boolean = null, $hasActiveCompanies: Boolean = null, $hasNationalities: Boolean = null) {
  listCountries(
    filter: {pageNumber: $pageNumber, pageSize: $pageSize, keyword: $keyword, hasCompanies: $hasCompanies, hasActiveCompanies: $hasActiveCompanies, hasNationalities: $hasNationalities}
  ) {
    items {
      id
      name
      isdCode
      demonym
    }
    totalCount
  }
}
    `;

/**
 * __useListCountriesQuery__
 *
 * To run a query within a React component, call `useListCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCountriesQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageSize: // value for 'pageSize'
 *      keyword: // value for 'keyword'
 *      hasCompanies: // value for 'hasCompanies'
 *      hasActiveCompanies: // value for 'hasActiveCompanies'
 *      hasNationalities: // value for 'hasNationalities'
 *   },
 * });
 */
export function useListCountriesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListCountriesQuery, ListCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCountriesQuery, ListCountriesQueryVariables>(ListCountriesDocument, options);
}
export function useListCountriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCountriesQuery, ListCountriesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCountriesQuery, ListCountriesQueryVariables>(ListCountriesDocument, options);
}
// @ts-expect-error
export function useListCountriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ListCountriesQuery, ListCountriesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListCountriesQuery, ListCountriesQueryVariables>;
export function useListCountriesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCountriesQuery, ListCountriesQueryVariables>,
): Apollo.UseSuspenseQueryResult<ListCountriesQuery | undefined, ListCountriesQueryVariables>;
export function useListCountriesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCountriesQuery, ListCountriesQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListCountriesQuery, ListCountriesQueryVariables>(ListCountriesDocument, options);
}
export type ListCountriesQueryHookResult = ReturnType<typeof useListCountriesQuery>;
export type ListCountriesLazyQueryHookResult = ReturnType<typeof useListCountriesLazyQuery>;
export type ListCountriesSuspenseQueryHookResult = ReturnType<typeof useListCountriesSuspenseQuery>;
